export default function HowTo() {
  return (
    <div>
      <p>
        The DISGENET REST API enables users to programmatically access the DISGENET knowledge base by querying
        a collection of REST endpoints. To query the DISGENET REST API, registered users are assigned an API
        key that enables them to authenticate their queries. After accessing the DISGENET Web portal by
        providing their authentication credentials (i.e. username and password), users can retrieve their API
        key by clicking the "user detail" icon present in the top-right corner of the screen. In order to
        query the REST API of DISGENET, users should add to each API call an HTTP header with name equal to
        'Authorization' and value equal to their API key. The following sections of the DISGENET REST API
        documentation provide more details on the available REST endpoints and how to query each endpoint by
        describing examples of client programs in Python and R.{' '}
      </p>
    </div>
  );
}
